import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateInvoice } from "@/api/v1-jwt/invoice/invoice";
import { useAuth } from "@/providers/auth";
import { createErrorHandler } from "@/utils/errorHandler";

export const useUpdateInvoice = () => {
  const query = useQueryClient();
  const { cognitoId, clientId, userRole } = useAuth();

  const userId =
    userRole === "admin" || userRole === "auth_user" ? clientId : cognitoId;

  return useMutation({
    mutationFn: async ({ id, ...payload }) =>
      await updateInvoice({ userId, invoiceId: id, payload }),
    onSuccess: () => {
      query.invalidateQueries(["invoices"]);
    },
    onError: createErrorHandler({
      customHandlers: {
        409: (error) => error.response?.data?.error_message || "Invoice conflict. Please check the values provided.",
      },
    }),
  });
};
